function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  className: styles["a"] || "a",
  d: "M2 5h2V3H2v2zm0 4h2V7H2v2zm0 4h2v-2H2v2zm0 4h2v-2H2v2zM6 5h8V3H6v2zm2.7 15H0V0h16v6.646a7.964 7.964 0 00-1.5-.146c-.973 0-1.9.183-2.763.5H6v2h2.7a8.062 8.062 0 00-1.386 2H6v2h.646a7.964 7.964 0 00-.146 1.5c0 .169.015.334.025.5H6v2h.904A7.989 7.989 0 008.7 20zm5.8-.5c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5zm9.5 3.249V24h-1.251l-4.326-4.326A6.466 6.466 0 0114.5 21a6.5 6.5 0 116.5-6.5 6.466 6.466 0 01-1.326 3.923L24 22.749zM15 15h2v-2h-2v2zm-3 0h2v-2h-2v2z"
})));